import { Card, Stack, Typography } from '@mui/material';
import { fontWeights } from '@/@mui/tokens/font-weights';
import { LocationInfo } from '@/packages/my-profile/components/preferences-section/components/location-info';
import { Modalities } from '@/packages/my-profile/components/preferences-section/components/modalities';
import { MonthlyBudget } from '@/packages/my-profile/components/preferences-section/components/monthly-budget';
import { WeeklyAvailability } from '@/packages/my-profile/components/preferences-section/components/weekly-availability';

export const PreferencesSection = () => {
  return (
    <Card>
      <Typography fontWeight={fontWeights.fontWeightSemibold} mb={2}>
        Preferências
      </Typography>
      <Stack spacing={2}>
        <LocationInfo />
        <Modalities />
        <MonthlyBudget />
        <WeeklyAvailability />
      </Stack>
    </Card>
  );
};
